import { Box, Center, SimpleGrid, Stack } from "@chakra-ui/react";
import React, { FC } from "react";
import { Else, If, Then } from "react-if";

import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import LayoutCarouselThumbnail from "@modules/Layout/components/CarouselThumbnail";
import { Banner } from "@modules/Layout/models/banner";
import { MediaCoverHero } from "../style";
import LinkBreadcrumb from "./LinkBreadcrumb";
import ActionButton from "./ActionButton";
import FluidImage from "./FluidImage";

interface IProps {
  data: Banner;
  buttonSize?: any;
}

const MediaThumbnailCover: FC<IProps> = ({ data, buttonSize }) => {
  if (!data) {
    return null;
  }

  const breadcrumb = data.breadcrumb;

  const thumbnails = data?.thumbnails?.data;

  const largeThumbnails: string[] = [];
  const mediumThumbnails: string[] = [];
  const smallThumbnails: string[] = [];

  thumbnails?.forEach((item) => {
    const { formats, url } = item?.attributes ?? {};

    if ("large" in formats) {
      console.log("formats?.large?.webp?.url", formats?.large?.webp?.url);
      largeThumbnails.push(formats?.large?.webp?.url);
    } else {
      largeThumbnails.push(url);
    }

    if ("medium" in formats) {
      mediumThumbnails.push(formats?.medium?.webp?.url ?? url);
    } else {
      mediumThumbnails.push(url);
    }

    if ("thumbnail" in formats) {
      smallThumbnails.push(formats?.thumbnail?.webp?.url);
    } else {
      mediumThumbnails.push(url);
    }
  });

  return (
    <MediaCoverHero>
      <If condition={breadcrumb?.length > 0}>
        <Then>
          <Box display={{ base: "none", md: "block" }}>
            <LinkBreadcrumb links={breadcrumb} py={4} />
          </Box>
        </Then>
      </If>
      <SimpleGrid
        columns={{ base: 1, md: 2 }}
        spacing={{ base: 0, md: 10, lg: 40 }}
      >
        <Center>
          <Stack mb={{ base: 0, md: 10 }} mt={{ base: 10, md: 0 }}>
            <ReactMarkdown children={data.content}></ReactMarkdown>

            <ActionButton actions={data.action} buttonSize={buttonSize} />
          </Stack>
        </Center>
        <Box>
          <If condition={thumbnails === null}>
            <Then>
              <Box />
            </Then>
            <Else>
              <If condition={thumbnails?.length === 1}>
                <Then>
                  <Center>
                    <Box mt={{ base: 0, md: "-30px" }}>
                      <FluidImage imageItem={{ data: thumbnails[0] }} />
                    </Box>
                  </Center>
                </Then>
                <Else>
                  <LayoutCarouselThumbnail
                    slide={mediumThumbnails.sort()}
                    thumbnails={smallThumbnails.sort()}
                    zoom={largeThumbnails.sort()}
                  />
                </Else>
              </If>
            </Else>
          </If>
        </Box>
      </SimpleGrid>
    </MediaCoverHero>
  );
};

export default MediaThumbnailCover;
